import { partition, propEq, sum } from 'ramda';
import { mapObject } from 'utils/functions';

import { OUTBOUND } from 'constants/booking';
import { marginTariff } from 'constants/tariffCodes';

export const groupMeals = (meals) => {
  const groupedMeals = {};
  meals.forEach((meal) => {
    const name = meal.name || 'Regular';
    groupedMeals[name] = groupedMeals[name] ? groupedMeals[name] + 1 : 1;
  });

  return groupedMeals;
};

export const getPaxSummary = (passengers, bookingItems) => {
  const passengerTypeCount = {};
  passengers.forEach((p) => {
    const { type, id } = p;
    const { price } = bookingItems.find((item) => item.passengerId === id);
    if (passengerTypeCount[type] && passengerTypeCount[type].count) {
      passengerTypeCount[type].count += 1;
      passengerTypeCount[type].price += price;
    } else {
      passengerTypeCount[type] = {
        count: 1,
        price
      };
    }
  });

  return passengerTypeCount;
};

export const splitLegsByDirection = partition(propEq('direction', OUTBOUND));

export const handleTotal = (passengerSummary) => (passengerSummary && sum(mapObject((p, v) => v.price, passengerSummary))) || null;

export const handleTotalExtras = (extraProducts) =>
  extraProducts.reduce(
    (total, product) => (!product.isCancelled && product.code !== marginTariff.MARGIN_TRAIN ? total + Number(product?.price ?? 0) : total),
    0
  );
